import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const fuelTypesAdapter = getAdapter({ idFieldName: 'value' });

const fuelTypesSlice = createSlice({
  name: 'fuelTypes',
  initialState: fuelTypesAdapter.getInitialState({
    source: null
  }),
  reducers: {
    setFuelTypes: (state, { payload: { fuelTypes, source } }) => {
      fuelTypesAdapter.setAll(state, fuelTypes);
      state.source = source;
    }
  }
});

const selectors = fuelTypesAdapter.getSelectors(({ fuelTypes }) => fuelTypes);

export const getFuelTypes = state => selectors.selectAll(state);

export const { setFuelTypes } = fuelTypesSlice.actions;

export default fuelTypesSlice.reducer;
